<script>
  import { VueMaskDirective as mask } from 'v-mask'
  import service from '../../../../domain/leiloes/services'
  import { isArray } from 'lodash'
  import { REAL_BRL } from '../../../../utils/helpers/money'
  import { VMoney } from 'v-money'
  import SelectTipoBem from './SelectTipoBem'
  import TipoBemCampos from './TipoBemCampos'
  import SelectMarca from './SelectMarca'
  import SelectModelo from './SelectModelo'
  import SelectComitente from './SelectComitente'

  /* const reactValores = function (c) {
    return {
      get () {
        return this.lote[c]
      },
      set (value) {
        if (typeof value === 'undefined') {
          return
        }
        if (value === null) {
          return
        }
        this.lote[c] = Number((value.replace(/[^0-9,]/g, '')).replace(',', '.'))
        // this.lote[c] = value
      }
    }
  } */

  let modeloTemplate = {
    anoFabricacao: null,
    anoModelo: null,
    modelo: null
  }

  export default {
    components: {
      SelectComitente,
      SelectModelo,
      SelectMarca,
      TipoBemCampos,
      SelectTipoBem
    },
    nome: 'novo-lote',
    directives: {mask, money: VMoney},
    data () {
      return {
        money: REAL_BRL,
        isLoading: false,
        // valorMinimoFormatado: '',
        leilao: {
          id: null,
          titulo: null,
          dataAbertura: null
        },
        lote: {
//          id: null,
          leilao: null,
          syncId: null,
          syncExtra: {
            codigoInterno: null
          },
          numero: null,
          titulo: null,
          tituloPregoeiro: null,
          descricao: null,
          descricaoPregoeiro: null,
          observacao: null,
          observacaoPregoeiro: null,
          destaque: null,
          status: null,
          condicao: null,
          valorTaxaArremate: null,
          valorTabelaFipe: null,
          valorAvaliacao: null,
          valorIncremento: null,
          valorInicial: null,
          valorMinimo: null,
          valorMeta: null,
          valorArremate: null,
          valorRemocao: null,
          valorIcms: null,
          valorIss: null,
          fotoDestaque: null,
          videoDestaque: null,
          unidadeMedida: null,
          lanceRestrito: false,
          tipo: null,
          comitente: null,
          marca: null,
          camposExtras: null,
          tipoCampos: null,
          modelo: Object.assign({}, modeloTemplate)
        },
        // valorTaxaArremate: '',
        // valorTabelaFipe: '',
        // valorAvaliacao: '',
        // valorIncremento: '',
        // valorInicial: '',
        // valorMinimo: '',
        // valorMeta: '',
        // valorRemocao: '',
        // Configurações
        loadTiposError: false,
        loadTiposText: 'Carregando',
        locais: null,
        leiloeiros: null,
        cadastroError: null,
        atualizadoSucesso: null,
        // timerPregaoC: null,
        condicoesLote: [
          {label: 'Sucata', value: 7, class: 'btn-black'},
          {label: 'Bom', value: 9, class: 'btn-success'},
          {label: 'Regular', value: 10, class: 'btn-info'},
          {label: 'Ruim', value: 11, class: 'btn-warning'},
          {label: 'Péssimo', value: 12, class: 'btn-danger'}
        ],
        valorInicial: '0,00',
        valorMinimoFormatado: '0,00',
        valorTaxaArremate: '0,00',
        valorTabelaFipe: '0,00',
        valorAvaliacao: '0,00',
        valorIncremento: '0,00',
        valorMinimo: '0,00',
        valorMeta: '0,00',
        valorRemocao: '0,00'
      }
    },
    computed: {},
    mounted () {
      this.start()
    },
    activated () {
    },
    destroyed () {
    },
    watch: {
      /* valorMinimoFormatado: function (val) {
        this.lote.valorMinimo = Number((this.valorMinimoFormatado.replace(/[^0-9,]/g, '')).replace(',', '.'))
      }, */
      /* valorTaxaArremate: function (val) {
        this.lote.valorTaxaArremate = Number((this.valorTaxaArremate.replace(/[^0-9,]/g, '')).replace(',', '.'))
      }, */
      /* valorTabelaFipe: function (val) {
        this.lote.valorTabelaFipe = Number((this.valorTabelaFipe.replace(/[^0-9,]/g, '')).replace(',', '.'))
      }, */
      /* valorAvaliacao: function (val) {
        this.lote.valorAvaliacao = Number((this.valorAvaliacao.replace(/[^0-9,]/g, '')).replace(',', '.'))
      }, */
      /* valorIncremento: function (val) {
        this.lote.valorIncremento = Number((this.valorIncremento.replace(/[^0-9,]/g, '')).replace(',', '.'))
      }, */
      /* valorInicial: function (val) {
       this.lote.valorInicial = Number((this.valorInicial.replace(/[^0-9,]/g, '')).replace(',', '.'))
       }, */
      /* valorMinimo: function (val) {
        this.lote.valorMinimo = Number((this.valorMinimo.replace(/[^0-9,]/g, '')).replace(',', '.'))
      }, */
      /* valorMeta: function (val) {
        this.lote.valorMeta = Number((this.valorMeta.replace(/[^0-9,]/g, '')).replace(',', '.'))
      }, */
      /* valorRemocao: function (val) {
        this.lote.valorRemocao = Number((this.valorRemocao.replace(/[^0-9,]/g, '')).replace(',', '.'))
      } */
    },
    methods: {
      start () {
        // this.loadTipos()
        if (this.$route.params.id) {
          this.$loaderOverlay.open().message('Aguarde enquanto carregamos o lote')
          service.findLote(this.$route.params.leilao, this.$route.params.id)
            .then((response) => {
              this.$loaderOverlay.hide()
              this.lote = response.data
              // TODO: Ajustar campos
              this.lote.leilao = this.lote.leilao.id
              if (typeof response.data.comitente !== 'undefined') {
                this.lote.comitente = (response.data.comitente !== null && typeof response.data.comitente['id'] !== 'undefined') ? response.data.comitente['id'] : null
              }
              if (typeof response.data.marca !== 'undefined' && response.data.marca !== null) {
                this.lote.marca = (response.data.marca !== null && typeof response.data.marca['id'] !== 'undefined') ? response.data.marca['id'] : null
                this.lote.marca !== null && this.atualizaMarca(this.lote.marca)
              }
              if (typeof response.data.tipo !== 'undefined' && response.data.tipo !== null) {
                this.lote.tipo = (response.data.tipo !== null && typeof response.data.tipo['id'] !== 'undefined') ? response.data.tipo['id'] : null
                this.atualizaCamposTipoBem(this.lote.tipo)
              }
              if (typeof response.data.modelo !== 'undefined' && response.data.modelo !== null) {
                if (response.data.modelo !== null) {
                  this.lote.modelo = response.data.modelo
                  if (typeof response.data.modelo.modelo !== 'undefined') {
                    this.lote.modelo.modelo = (response.data.modelo.modelo !== null && typeof response.data.modelo.modelo['id'] !== 'undefined') ? response.data.modelo.modelo['id'] : null
                  }
                }
              } else {
                this.lote.modelo = Object.assign({}, modeloTemplate)
              }
              if (typeof this.lote.tipoCampos !== 'undefined' && this.lote.tipoCampos !== null && this.lote.tipoCampos.length > 0) {
                for (let i = 0; i < this.lote.tipoCampos.length; i++) {
                  this.lote.tipoCampos[i].nome = this.lote.tipoCampos[i].tipo.nome
                  this.lote.tipoCampos[i].tipo = this.lote.tipoCampos[i].tipo.id
                }
              }
              this.$nextTick(() => {
                this.ajustaValores(true)
              })
              console.log(response)
            })
            .catch((response) => {
              this.$loaderOverlay.hide()
              console.log(response)
            })
        } else {
          this.$loaderOverlay.open().message('Aguarde')
          service.findSimple(this.$route.params.leilao)
            .then((response) => {
              this.$loaderOverlay.hide()
              this.leilao = response.data
              this.lote.leilao = response.data.id
            })
            .catch((response) => {
              this.$loaderOverlay.hide()
              window.responseError(response) // TODO: Verificar possibilidade de personalizar o erro na tela do usuário
              console.log(response)
            })
        }
      },
      ajustaValores (inversed) {
        inversed = inversed || false
        console.log('Inversed: ' + inversed)
        let fields = ['valorInicial', 'valorMinimo', 'valorTaxaArremate', 'valorTabelaFipe', 'valorAvaliacao', 'valorIncremento', 'valorMeta', 'valorRemocao']
        fields.forEach((field) => {
          if (inversed) {
            this[field] = this.lote[field]
          } else {
            this.lote[field] = Number((this[field].replace(/[^0-9,]/g, '')).replace(',', '.'))
          }
          console.log('Ajustando campo ' + field + ' que tem o valor novo ' + this.lote[field])
        })
        if (!inversed) {
          if (typeof this.lote.tipoCampos !== 'undefined' && this.lote.tipoCampos !== null && this.lote.tipoCampos.length > 0) {
            for (let i = 0; i < this.lote.tipoCampos.length; i++) {
              this.lote.tipoCampos[i].nome && delete this.lote.tipoCampos[i].nome
            }
          }
        }
      },
      submit () {
        this.ajustaValores()
        this.cadastroError = null
        this.$loaderOverlay.open().message('Processando')
        this.$bar.start()
        window.setTimeout(() => {
          this.$loaderOverlay.message('Aguarde, registrando lote...')
        }, 1000)
        service.cadastroLote(this.lote, this.$route.params.id).then((response) => {
          let callbackEnd = () => {
            this.$bar.finish()
            this.$loaderOverlay.hide()
            if (this.$route.params.id) {
              // Continua na mesma tela de edição
              // this.$nextTick(() => {
              this.start()
              this.atualizadoSucesso = true
              this.$el.querySelector('#sucessMsg').focus()
              // })
            } else {
              // Redirecionr para tela de visualização do leilão criado
              this.$router.push({name: 'lotes.visualizar', params: {id: response.data.id}})
            }
          }
          // File
          let necessarySendForm = false
          let formData = new FormData()
          /* let imagemDestaque = document.querySelector('#fotoDestaque')
           if (typeof imagemDestaque.files[0] !== 'undefined') {
           if (imagemDestaque.files[0] !== null) {
           necessarySendForm = true
           formData.append('fotoDestaque', imagemDestaque.files[0], imagemDestaque.files[0].name)
           }
           } */
          if (necessarySendForm) {
            window.setTimeout(() => {
              this.$loaderOverlay.message('Fazendo upload dos arquivos...')
            }, 1000)
            service.uploadArquivosLote(response.data.id, formData)
              .then((response) => {
                callbackEnd()
              })
              .catch((response) => {
                window.alert('Falha ao fazer o upload dos arquivos do lote.')
                callbackEnd()
              })
          } else {
            callbackEnd()
          }
        }).catch((response) => {
          this.$bar.finish()
          this.$loaderOverlay.hide()
          this.cadastroError = response.data.errors
          this.$nextTick(() => {
            this.$refs.error.focus()
          })
          console.log(response)
        })
      },
      atualizaCamposTipoBem (id) {
        this.lote.tipo = id
        this.$refs.tipoBemCampos.load(id)
        this.$refs.marcas.load(id)
      },
      setValuesInTipoBemCampos (v) {
        this.lote.tipoCampos = v
      },
      atualizaMarca (id) {
        /* if (this.lote.modelo && this.lote.modelo.modelo) {
          this.lote.modelo.modelo = null
        } */
        console.log(id)
        this.$refs.modelos.load(id)
      },
      atualizaModelo (id) {
        this.lote.modelo.modelo = id
      },
      atualizaComitente (id) {
        this.lote.comitente = id
      },
      __ajustaValores () {
        this.lote.valorInicial = Number((this.lote.valorInicial.replace(/[^0-9,]/g, '')).replace(',', '.'))
        this.lote.valorMinimo = Number((this.lote.valorMinimo.replace(/[^0-9,]/g, '')).replace(',', '.'))
        this.lote.valorTaxaArremate = Number((this.lote.valorTaxaArremate.replace(/[^0-9,]/g, '')).replace(',', '.'))
        this.lote.valorTabelaFipe = Number((this.lote.valorTabelaFipe.replace(/[^0-9,]/g, '')).replace(',', '.'))
        this.lote.valorAvaliacao = Number((this.lote.valorAvaliacao.replace(/[^0-9,]/g, '')).replace(',', '.'))
        this.lote.valorIncremento = Number((this.lote.valorIncremento.replace(/[^0-9,]/g, '')).replace(',', '.'))
        this.lote.valorMeta = Number((this.lote.valorMeta.replace(/[^0-9,]/g, '')).replace(',', '.'))
        this.lote.valorRemocao = Number((this.lote.valorRemocao.replace(/[^0-9,]/g, '')).replace(',', '.'))
      },
      printError (err) {
        if (isArray(err)) {
          return err[0]
        }
        return err
      }
    }
  }
</script>

<template>
  <div>
    <div>
      <div class="bg-light lter b-b wrapper-md">
        <div class="row">
          <div class="col-sm-6"><h1 class="m-n font-thin h3">Cadastro de Lote</h1></div>
          <div class="col-sm-6">
            <router-link v-if="lote.id" :to="{name: 'lotes.visualizar', params: {leilao: lote.leilao, id: lote.id}}"
                         class="pull-right hidden-print" style="clear: left"><strong class="label no-radius bg-info">Voltar</strong>
              para o lote
            </router-link>
            <router-link v-else :to="{name: 'leiloes.visualizar', params: {id: lote.leilao}}"
                         class="pull-right hidden-print" style="clear: left"><strong class="label no-radius bg-info">Voltar</strong>
              para a tela do leilão
            </router-link>
          </div>
        </div>
      </div>
      <div class="wrapper-md">
        <div class="panel panel-default">
          <div class="panel-body">
            <div tabindex="-1" ref="error" v-if="cadastroError !== null" class="alert alert-danger">
              <div class="m-b-sm font-bold">Erro ao registrar o leilão, corrija e tente novamente</div>
              <p v-for="(erro, key) in cadastroError">{{printError(erro)}}</p>
            </div>
            <a name="sucessMsg" id="sucessMsg" href="javascript:void(0)" ref="sucessMsg"></a>
            <div tabindex="-1" ref="error" v-if="atualizadoSucesso !== null" class="alert alert-success">
              <div class="font-bold">Atualizado com sucesso!</div>
            </div>
            <form @submit.prevent.stop="" class="bs-example form-horizontal">
              <div class="clearfix">

                <div class="alert alert-warning" v-if="leilao.id">
                  O lote está relacionado ao leilão <strong>#{{ leilao.id }} -
                  {{ leilao.titulo }} -
                  a ser realizado em {{ moment(leilao.dataAbertura.date).format('LLL') }}</strong>
                </div>

                <div class="col-md-6">
                  <div class="form-group">
                    <label class="col-lg-2 control-label">Número</label>
                    <div class="col-lg-10">
                      <input type="text" v-model="lote.numero" class="form-control w-auto"/>
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="col-lg-2 control-label">Título</label>
                    <div class="col-lg-10">
                      <input type="text" v-model="lote.titulo" class="form-control"/>
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="col-lg-2 control-label">Descrição</label>
                    <div class="col-lg-10">
                      <textarea class="form-control" v-model="lote.descricao" rows="3"
                                style="resize: none"></textarea>
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="col-lg-2 control-label">Valor inicial</label>
                    <div class="col-lg-10">
                      <input type="text" placeholder="R$ 0,00" v-money="money" v-model="valorInicial"
                             class="form-control"/>
                    </div>
                  </div>

                  <div class="form-group">
                    <label class="col-lg-2 control-label">Destaque</label>
                    <div class="col-lg-10">
                      <label class="i-switch bg-success m-t-xs m-r">
                        <input type="checkbox" v-model="lote.destaque">
                        <i></i>
                      </label>
                    </div>
                  </div>

                  <div class="form-group">
                    <label class="col-lg-2 control-label">Observação</label>
                    <div class="col-lg-10">
                      <textarea class="form-control" v-model="lote.observacao" rows="3"
                                style="resize: none"></textarea>
                    </div>
                  </div>

                  <div class="form-group">
                    <label class="col-lg-2 control-label">Título Tela Pregoeiro</label>
                    <div class="col-lg-10">
                      <input type="text" v-model="lote.tituloPregoeiro" class="form-control"/>
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="col-lg-2 control-label">Descrição Tela Pregoeiro</label>
                    <div class="col-lg-10">
                      <textarea class="form-control" v-model="lote.descricaoPregoeiro" rows="3"
                                style="resize: none"></textarea>
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="col-lg-2 control-label">Observação Tela Pregoeiro</label>
                    <div class="col-lg-10">
                      <textarea class="form-control" v-model="lote.observacaoPregoeiro" rows="3"
                                style="resize: none"></textarea>
                    </div>
                  </div>

                </div>
                <div class="col-md-6 text-center">
                  <a class="card1">
                    <div class="p-item lote-item-status1">
                      <div class="cont-img-destaque">
                        <span>{{ lote.numero ? '000'.substring(0, 3 - String(lote.numero).length) + String(lote.numero) : '000'
                          }}</span>
                        <div v-if="lote.urlMin" class="img"><img width="226" height="169" :src="lote.urlMin"></div>
                        <div v-else class="img">Imagem</div>
                      </div>
                      <div class="cont-info-destaque">
                        <h3>
                          {{ lote.titulo }}
                        </h3>
                        <p>{{ lote.descricao }}</p>
                        <p v-if="lote.valorInicial" class="minimo">R$ {{ lote.valorInicial }}</p>
                      </div>
                    </div>
                  </a>
                </div>

              </div>

              <hr>

              <div class="col-md-6">

                <div class="form-group">
                  <label class="col-lg-2 control-label">Condições</label>
                  <div class="col-lg-10">
                    <u-button-group v-model="lote.condicao" :options="condicoesLote"></u-button-group>
                  </div>
                </div>

                <select-comitente v-model="lote.comitente" :value="lote.comitente" ref="comitentes"></select-comitente>

                <div class="form-group">
                  <label class="col-lg-2 control-label">Tipo de Bem</label>
                  <div class="col-lg-10">
                    <!-- TODO: Criar uma pesquisa em nova janela, possibilitando multi-level option -->
                    <select-tipo-bem @atualizaCamposTipoBem="atualizaCamposTipoBem"
                                     v-model="lote.tipo"></select-tipo-bem>
                  </div>
                </div>

                <tipo-bem-campos v-model="lote.tipoCampos" :value="lote.tipoCampos"
                                 @updateTipoBemCampos="setValuesInTipoBemCampos" ref="tipoBemCampos"></tipo-bem-campos>

                <select-marca @atualizaMarca="atualizaMarca" v-model="lote.marca" :value="lote.marca"
                              ref="marcas"></select-marca>

                <select-modelo v-model="lote.modelo.modelo" :value="lote.modelo.modelo" ref="modelos"></select-modelo>

                <div class="form-group">
                  <label class="col-lg-2 control-label">Ano Fabricação</label>
                  <div class="col-lg-10">
                    <input type="text" placeholder="" v-model="lote.modelo.anoFabricacao" class="form-control w-auto"
                           size="10"/>
                  </div>
                </div>

                <div class="form-group">
                  <label class="col-lg-2 control-label">Ano Modelo</label>
                  <div class="col-lg-10">
                    <input type="text" placeholder="" v-model="lote.modelo.anoModelo" class="form-control w-auto"
                           size="10"/>
                  </div>
                </div>

              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label class="col-lg-2 control-label">Taxa de Arremate</label>
                  <div class="col-lg-10">
                    <input type="text" placeholder="R$ 0,00" v-model="valorTaxaArremate" v-money="money"
                           class="form-control"/>
                  </div>
                </div>

                <div class="form-group">
                  <label class="col-lg-2 control-label">Tabela Fipe</label>
                  <div class="col-lg-10">
                    <input type="text" placeholder="R$ 0,00" v-model="valorTabelaFipe" v-money="money"
                           class="form-control"/>
                  </div>
                </div>

                <div class="form-group">
                  <label class="col-lg-2 control-label">Avaliação</label>
                  <div class="col-lg-10">
                    <input type="text" placeholder="R$ 0,00" v-model="valorAvaliacao" v-money="money"
                           class="form-control"/>
                  </div>
                </div>

                <div class="form-group">
                  <label class="col-lg-2 control-label">Incremento</label>
                  <div class="col-lg-10">
                    <input type="text" placeholder="R$ 0,00" v-model="valorIncremento" v-money="money"
                           class="form-control"/>
                  </div>
                </div>

                <div class="form-group">
                  <label class="col-lg-2 control-label">Valor Inicial</label>
                  <div class="col-lg-10">
                    <input type="text" placeholder="R$ 0,00" v-model="valorInicial" v-money="money"
                           class="form-control"/>
                  </div>
                </div>

                <div class="form-group">
                  <label class="col-lg-2 control-label">Mínimo</label>
                  <div class="col-lg-10">
                    <input type="text" placeholder="R$ 0,00" v-model="valorMinimo" v-money="money"
                           class="form-control"/>
                  </div>
                </div>

                <div class="form-group">
                  <label class="col-lg-2 control-label">Meta</label>
                  <div class="col-lg-10">
                    <input type="text" placeholder="R$ 0,00" v-model="valorMeta" v-money="money" class="form-control"/>
                  </div>
                </div>

                <div class="form-group">
                  <label class="col-lg-2 control-label">Custo Remoção</label>
                  <div class="col-lg-10">
                    <input type="text" placeholder="R$ 0,00" v-model="valorRemocao" v-money="money"
                           class="form-control"/>
                  </div>
                </div>

                <div class="form-group">
                  <label class="col-lg-2 control-label">ICMS %</label>
                  <div class="col-lg-10">
                    <input type="number" placeholder="%" v-model="lote.valorIcms" class="form-control"/>
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-lg-2 control-label">ISS %</label>
                  <div class="col-lg-10">
                    <input type="number" placeholder="%" v-model="lote.valorIss" class="form-control"/>
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-lg-2 control-label">Unidade de Medida</label>
                  <div class="col-lg-10">
                    <input type="text" placeholder="Deixe em branco para nenhuma" v-model="lote.unidadeMedida" class="form-control"/>
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-lg-2 control-label">Lance Restrito</label>
                  <div class="col-lg-10">
                    <select v-model="lote.lanceRestrito" class="form-control w-auto w-full-xs">
                      <option disabled value="">Selecione</option>
                      <option :value="false">Não</option>
                      <option :value="true">Sim</option>
                    </select>
                  </div>
                </div>

              </div>

              <div class="clearfix"></div>

              <hr>
              <div class="row wrapper">
                <u-button @click="submit" class="btn m-b-xs w-xs btn-info m-r-xs">
                  <span v-if="!lote.id">Cadastrar</span>
                  <span v-if="lote.id">Atualizar</span>
                </u-button>
                <u-button class="btn m-b-xs w-xs m-r-xs btn-default">Cancelar</u-button>
                <span v-if="!lote.id">Ao cadastrar, o status do lote será <span class="text-info">Rascunho</span>, para publicá-lo, altere o status após o cadastro.</span>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// NovoLote.vue?765af286